import { DomainError } from './errors';
import { MAX_EVENTS } from './model';

const eventLimitLabel = new Intl.NumberFormat('fr-FR').format(MAX_EVENTS);

export const assertEventHistoryWithinLimit = (eventCount: number): void => {
  if (eventCount <= MAX_EVENTS) return;
  throw new DomainError(
    `L’historique local contient ${eventCount} événements, au-delà du plafond de ${eventLimitLabel}. Aucune donnée n’a été supprimée ni tronquée.`,
    'LIMIT_REACHED',
  );
};

export const assertCanAppendInventoryEvent = (eventCount: number): void => {
  if (eventCount < MAX_EVENTS) return;
  throw new DomainError(
    `La limite locale de ${eventLimitLabel} événements est atteinte. Aucune modification n’a été enregistrée ; exportez une sauvegarde avant de poursuivre.`,
    'LIMIT_REACHED',
  );
};
